import { useEffect, useState } from 'react'

export const useViewport = () => {
  const MOBILE_BREAKPOINT_PIXELS = 992

  const [isMobile, setMobile] = useState(false)

  useEffect(() => {
    setMobile(window.innerWidth < MOBILE_BREAKPOINT_PIXELS)

    const handleResize = () => {
      setMobile(window.innerWidth < MOBILE_BREAKPOINT_PIXELS)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    const setVhVariable = () => {
      document.documentElement.style.setProperty(
        '--100vh',
        `${window.innerHeight}px`,
      )
    }

    setVhVariable()

    window.addEventListener('resize', setVhVariable)

    return () => window.removeEventListener('resize', setVhVariable)
  }, [])

  useEffect(() => {
    const viewportMeta = document?.querySelector('meta[name=viewport]')

    if (!viewportMeta) {
      return
    }

    if (isMobile) {
      viewportMeta.setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, shrink-to-fit=no, viewport-fit=cover',
      )
      const preventGesture = (event: Event) => event.preventDefault()

      document.addEventListener('gesturestart', preventGesture)

      return () => {
        document.removeEventListener('gesturestart', preventGesture)
      }
    } else {
      viewportMeta.setAttribute(
        'content',
        'width=device-width, initial-scale=1',
      )
    }
  }, [isMobile])

  return { isMobile }
}
